import { render, staticRenderFns } from "./AguasDeBugaForm.vue?vue&type=template&id=e15a6ce0"
import script from "./AguasDeBugaForm.vue?vue&type=script&lang=js"
export * from "./AguasDeBugaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports